<template>
    <div class="row p-3" dir="auto">
        <label :for="question.label">
            {{ question.label }}
        </label>

        <component
            :is="`${question.type}-question`"
            :question="question"
            :class="{ 'is-invalid': !!error }"
            :error="!!error"
            @input="onInput"
        />

        <div class="invalid-feedback">
            {{ error }}
        </div>
    </div>
</template>

<script>
import types from './types';

export default {
    components: {
        ...types
    },

    props: {
        question: {
            type: Object,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    computed: {
        serverError() {
            return this.serverErrors.find(
                item => item.param === this.question.label
            );
        },

        error() {
            const {
                $error,
                required,
                isFormatValid,
                email,
                correctQuantity
            } = this.validation;

            if (this.serverError) {
                return this.serverError.message;
            }

            if (!$error) {
                return '';
            }

            if (!required) {
                return 'Should not be empty!';
            }

            if (!isFormatValid) {
                return 'Format is not valid!';
            }

            if (!email) {
                return 'Email is not valid!';
            }

            if (!correctQuantity) {
                const { minOptions, maxOptions } = this.question.settings;

                return `Please choose items between ${minOptions} and ${maxOptions}`;
            }

            return 'Something is wrong... 🤔';
        }
    },

    methods: {
        onInput(value) {
            return this.$emit('input', value);
        }
    }
};
</script>
